import {
  Configuration,
  EventMessage,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { AuthenticationResult } from '@azure/msal-common/dist/response/AuthenticationResult';

import { envConfig } from '../../../../config';
import { castTo } from '../../../shared/utils/cast-to';
import { updateLocalStorageInformation } from '../../../shared/utils/update-local-storage-information/update-local-storage-information.util';

export const config: Configuration = {
  auth: {
    clientId: envConfig.auth.clientId,
    authority: envConfig.auth.authority,
    knownAuthorities: envConfig.auth.knownAuthorities,
    redirectUri: envConfig.auth.redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

const publicClientApplication = new PublicClientApplication(config);

publicClientApplication.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const authResult: AuthenticationResult = castTo<AuthenticationResult>(
      event.payload
    );

    updateLocalStorageInformation(authResult);
  }

  if (event.eventType === EventType.LOGOUT_SUCCESS) {
    updateLocalStorageInformation();
  }
});

export default publicClientApplication;
